import { render, staticRenderFns } from "./ThemeSwitcher.vue?vue&type=template&id=46aba0ba&scoped=true"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=ts"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./ThemeSwitcher.vue?vue&type=style&index=0&id=46aba0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@7.1.2_webpack@5.102.0__ejs@3.1.1_b418e0daa871bcba12ba464f72b9348d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aba0ba",
  null
  
)

export default component.exports